import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { TicketTagColored, BoardService, TicketTag } from 'src/app/_provider/boards/board.service';
import { DarkmodeService } from 'src/app/_provider/darkmode.service';
import { FeedbackService, MsgType, VibrateType } from 'src/app/_provider/feedback.service';
import { SaveService } from 'src/app/_provider/save.service';

@Component({
  selector: 'app-tag-edit',
  templateUrl: './tag-edit.page.html',
  styleUrls: ['./tag-edit.page.scss', "../../../setting-main.scss"],
})
export class TagEditPage implements OnInit {

  @ViewChild("picker") picker: ElementRef

  public isNew: boolean = false

  public tag: TicketTagColored

  public colors: string[] = [
    "#6576AD", "#ff6666", "#8caf6e", "#C9B235", "#d857ce", "#E86017", "#17E8c5", "#17Be48", "#E8177C"
  ]

  constructor(
    private modalCtrl: ModalController,
    private darkmode: DarkmodeService,
    private feedback: FeedbackService,
    private boardSrv: BoardService,
    private saveSrv: SaveService.Settings
  ) { 
  }

  ngOnInit() {
    if(this.isNew && !this.tag) this.tag = {id: -1, description: "", hex: "#6576AD", rgba: this.getRGBAString("#6576AD")}
  }

  ngAfterViewInit(){
    this.picker.nativeElement.addEventListener("input", (event: any)=>{
      const color = event.target.value
      this.tag.hex = color
      this.tag.rgba = this.getRGBAString(color)
    })
  }

  public selectColor(color: string){
    this.feedback.vibrate(VibrateType.light)
    this.tag.hex = color
    this.tag.rgba = this.getRGBAString(color)
  }

  public openColorPicker(){
    this.feedback.vibrate(VibrateType.light)
    document.getElementById("pickerLabel").click()
  }

  private getRGBAString(hex: string){
    const rgb: { r: number; g: number; b: number; } = this.darkmode.hexToRgb(hex)
    return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.1)`
  }

  public changeCustomColor(){
    console.log(this.tag.hex);
    
  }

  public async back(){
    await this.modalCtrl.dismiss()
  }

  public async deleteTag(){
    if(!(await this.feedback.confirm(`Möchten Sie den Tag "${this.tag.description}" wirklich löschen?`, "Löschen", "Abbrechen"))) return
    await this.feedback.updateLoading("Löschen...")
    const result: HttpFunctionResult<any> = await this.saveSrv.deleteTicketTag(this.tag.id)
    await this.feedback.hideLoading()
    if(!result.success) return
    this.boardSrv.tags.splice(this.boardSrv.tags.findIndex(t => t.id == this.tag.id), 1)
    await this.modalCtrl.dismiss()
  }

  public async save(){

    if(!this.tag.description) return await this.feedback.showError("Bitte geben Sie eine Bezeichnung ein.")

    await this.feedback.updateLoading("Speichern...")

    let result: HttpFunctionResult<TicketTag>

    const tag: TicketTag = {
      id: this.tag.id,
      description: this.tag.description,
      color: this.tag.hex
    }

    if(this.isNew) result = await this.saveSrv.createTicketTag(tag)
    else result = await this.saveSrv.updateTicketTag(tag)
    
    await this.feedback.hideLoading()
    
    if(!result.success) return
    await this.modalCtrl.dismiss(result.data)
  }

}
